export * from "./types";
import slice from "./slice";
export const { resetPostInfusionClinicInfoAction, resetPutInfusionClinicInfoAction } = slice.actions;
